/**
 * JsonDenormalizer.js
 *
 * This class transforms data from a JSON API standard response
 * into a more user-friendly structure with nested objects to
 * represent relationships.
 *
 * Haven't found any existing library that will also
 * allow the execution of any UI-side transformers.
 */

import _ from 'lodash/lodash'

export default class JsonDenormalizer {

  static denormalize (jsonResponse) {

    if (!_.isPlainObject(jsonResponse)) return

    // For coding convenience, we'll be forcing single objects into an array
    // (we'll restore to initial object vs array of objects before return)
    let bundled = []
    const data = _.get(jsonResponse, 'data')
    const included = _.get(jsonResponse, 'included', [])

    // We should have either a single object an array of objects in data source
    if (!_.isPlainObject(data) && !_.isArray(data)) return

    // This is where we temporarily force an array for coding convenience
    const results = Array.isArray(data) ? data : [data]

    const transformers = {
      // "firm": FirmTransformer,
      // "user": UserTransformer,
      // "etc": EtcTransformer,
    }

    const transform = (obj, type) => {
      const transformer = type && transformers.hasOwnProperty(type)
        ? transformers[type]
        : false;

      return transformer
        ? transformer.transform(obj)
        : Object.assign({}, {id: obj.id}, obj.attributes);
    }

    results.forEach(obj => {

      const type = _.get(obj, 'type')
      const relationships = _.get(obj, 'relationships', {})

      // Our transformers should be able to handle it if we don't do the following re-assembly
      // let entity = _.extend({}, {id: obj.id}, obj.attributes);
      let entity = transform(obj, type)

      let associations = {} // key => object|array like {creator: userObj} OR {order: [orderObj1, orderObj2]}

      _.forEach(relationships, (rel, k) => {

        const summary = rel.data

        // Find the linked data in the "includes" object
        // (again, we'll insist on array for looping)
        let includes = []
        let summaries = Array.isArray(summary) ? summary : [summary]

        summaries.forEach(s => {
          // Using `_.matches` iteratee shorthand here.
          // https://lodash.com/docs/4.17.11#filter
          let matches = _.filter(included, s)

          if (matches.length) {
            matches.forEach(m => {
              if (_.keys(_.get(m, 'relationships', {})).length > 0) {
                includes.push(
                  this.denormalize({
                    data: m,
                    included
                  })
                )
              } else {
                includes.push(transform(m, s.type))
              }
            })
          }
        })

        associations[k] = Array.isArray(summary) ? includes : includes.shift()
      })

      // Place relationships directly onto the entity
      // (warn if overwriting existing property)
      _.forEach(associations, (assoc, assoc_name) => {
        if (entity.hasOwnProperty(assoc_name)) {
          // window.console &&
          //   console.log(
          //     `[WARNING] Object property "${assoc_name}" replaced with relationship data.`
          //   )
        }

        entity[assoc_name] = assoc
      })

      bundled.push(entity)
    })

    // Now return data in original jsonResponse format
    // (single object vs an array of objects)
    return Array.isArray(data) ? bundled : bundled.shift()
  }
}
